import React from "react";
import ReactModal from "react-modal";
import { useSelector } from "react-redux";

import { LayoutReport } from "./LayoutReport";
import { LayoutClientsCountReport } from "./LayoutClientsCountReport/LayoutClientsCountReport";
import { viewReports } from "../../../helpers/data-constants";
import { LayoutDebtReport } from "./LayoutDebtReport/LayoutDebtReport";

const ReportModal = ({
  open,
  onClose,
  dateRange,
  title,
  type,
  documentType,
}) => {
  const { accessFeatures } = useSelector(({ user }) => user);
  const isOpen = !!open;
  const isClientProfile =
    accessFeatures["clients.report"] && type === viewReports.CLIENTS_COUNT;
  const isDebtReport = type === viewReports.DEBT_REPORT;

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-modal"
      overlayClassName="modal-overlay"
    >
      {isClientProfile ? (
        <LayoutClientsCountReport onClose={onClose} title={title} />
      ) : isDebtReport ? (
        <LayoutDebtReport onClose={onClose} title={title}/>
      ) 
      : (
        <LayoutReport
          open={isOpen}
          onClose={onClose}
          dateRange={dateRange}
          title={title}
          type={type}
          documentType={documentType}
        />
      )}
    </ReactModal>
  );
};

export default ReportModal;
